
/**
 * @Description //TODO websocket 定义
 * @author Zhangbin
 * @date 2021/4/30 16:54
 * @Ver 1.3.1
 * @extends Vue
 */

export function Soket() {
	
	// 记录 webSoket
	let Socket = ''
	// 心跳定时器
	let setIntervalWesocketPush = null
	// 自动重连 flag
	let autoRecreatFlag = true;
	
	// webSoket 路径
	let wsUrl;
	// 心跳包
	let wsPingStr;
	// 自定义方法 连接打开
	let wsOnopen;
	// 自定义方法 连接发生错误
	let wsOnerror;
	// 自定义方法 连接关闭
	let wsOnclose;
	// 自定义方法 消息推送
	let wsOnmessage;
	// 关键字 区别不同webSoket
	let wsKey;
	
	/**
	 * TODO 设置 自动重连flag
	 * @param {bleach} recreatFlag 默认true
	 */
	function setWsParams(option) {
		
		// webSoket 路径
		if (option.wsUrl) {
			wsUrl = option.wsUrl;
		}
		
		// 关键字 区别不同webSoket
		if (option.wsKey) {
			wsKey = option.wsKey;
		}
		
		// 设置自动重连 flag
		if (option.autoRecreatFlag === false || option.autoRecreatFlag === true) {
			autoRecreatFlag = option.autoRecreatFlag;
		}
		
		// 心跳包
		wsPingStr = option.wsPingStr;
		// 触发 onmessage
		wsOnmessage = option.wsOnmessage;
		// 连接打开
		wsOnopen = option.wsOnopen;
		// 连接发生错误
		wsOnerror = option.wsOnerror;
		// 连接关闭
		wsOnclose = option.wsOnclose;
		
	}
	
	/**
	 * 建立websocket连接
	 * @param {string} url ws地址
	 */
	const createSocket = (url = wsUrl, _wsKey = wsKey) => {
		
		// webSoket 路径
		if (url) {
			wsUrl = url;
		}
		
		// 关键字 区别不同webSoket
		if (_wsKey) {
			wsKey = _wsKey;
		}
		
		Socket && Socket.close();
		if (!Socket) {
	    
		    if ('WebSocket' in window) {
				Socket = new WebSocket(url);
			} else if ('MozWebSocket' in window) {
			    Socket = new MozWebSocket(url);
			} else {
			    Socket = new SockJS(url);
			};
		    
			Socket.onopen = wsOnopen ? wsOnopen : onopenWS;
		    Socket.onmessage = wsOnmessage ? wsOnmessage : onmessageWS;
		    Socket.onerror = onerrorWS;
		    Socket.onclose = oncloseWS;
		    
		} else {
			console.log('websocket已连接...');
		}
	}
	
	/**打开WS之后发送心跳 */
	const onopenWS = () => {
		console.log('连接已打开...');
		sendPing();
	}
	
	/**连接失败重连 */
	const onerrorWS = (event) => {
		console.log('webSoket发生错误...');
		
		// onerror 回调
		wsOnerror && wsOnerror(event);
		// 不可自动重连 中止
		if (!autoRecreatFlag) return false;
		
		Socket.close();
		clearInterval(setIntervalWesocketPush);
		if (Socket.readyState !== 3) {
			Socket = null
			createSocket();
		}
	}
	
	/**WS数据接收统一处理 */
	const onmessageWS = e => {
		window.dispatchEvent(new CustomEvent('onmessageWS' + (wsKey ? wsKey : ''), {
			detail: {
				data: e.data
			}
		}));
	}
	
	/**
	 * 发送数据但连接未建立时进行处理等待重发
	 * @param {any} message 需要发送的数据
	 */
	const connecting = message => {
		setTimeout(() => {
			if (!Socket || Socket.readyState === 0) {
				connecting(message);
			} else {
				let jsonStr = typeof message == 'string' ? message : JSON.stringify(message);
				Socket.send(jsonStr);
			}
		}, 1000);
	}
	
	/**
	 * 发送数据
	 * @param {any} message 需要发送的数据
	 */
	const sendWSPush = message => {
		if (Socket !== null && Socket.readyState === 3) {
			Socket.close();
			createSocket();
		} else if (Socket.readyState === 1) {
			let jsonStr = typeof message == 'string' ? message : JSON.stringify(message);
			Socket.send(jsonStr);
		} else if (Socket.readyState === 0) {
			connecting(message);
		}
	}
	
	/**断开重连 */
	const oncloseWS = (event) => {
		// console.log('oncloseWS', new Date().getTime());
		
		// 关闭心跳计时器
		clearInterval(setIntervalWesocketPush)
		console.log('websocket已断开....');
	  	
	  	// onclose 回调
	  	wsOnclose && wsOnclose(event);
		// 不可自动重连 中止
		if (!autoRecreatFlag) {
			if (Socket.readyState !== 2) {
				Socket = null
			}
			return false;
		};
		
		if (Socket.readyState !== 2) {
			Socket = null
			createSocket();
		}
	}
	
	/**
	 * TODO 关闭webSoket
	 */
	function endWS() {
		// 设置 自动重连 flag
		autoRecreatFlag = false;
		
		clearInterval(setIntervalWesocketPush);
		
		// 关闭连接
		Socket && Socket.readyState === 1 && Socket.close();
	}
	
	/**发送心跳
	 * @param {number} time 心跳间隔毫秒 默认5000
	 * @param {string} ping 心跳名称 默认字符串ping
	 */
	const sendPing = (time = 0.5* 60 * 1000, ping = 'ping') => {
		// 关闭心跳 计时器
		clearInterval(setIntervalWesocketPush);
		
		var jsonStr = 'ping';
		
		if (ping == 'ws_out_ping') {
			const code = 0;// 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置
			const _time = new Date().getTime();
			const sign = window.$this.$secret.md5(_time + "{" + code + "}");
			const argJson = {
				code: code,
				time: _time,
				sign: sign,
				key: window.$this.$store.state.loginKey,
			};
			jsonStr = JSON.stringify(argJson);
		}
		
		// let jsonStr = wsPingStr ? wsPingStr : typeof ping == 'string' ? ping : JSON.stringify(ping);
		
		// 发送心跳包
		Socket.send(jsonStr);
		// 心跳包计时器
		/*setIntervalWesocketPush = setInterval(() => {
			Socket.send(jsonStr);
		}, time)*/
	}
	
	// 参数设置
	this.setWsParams = setWsParams;
	// 建立websocket连接
	this.createSocket = createSocket;
	// 发送数据
	this.sendWSPush = sendWSPush;
	// 关闭 webSoket
	this.endWS = endWS;
	// 心跳
	this.sendPing = sendPing;
}

/**
 * 使用
 * 

// 在main.js或需要使用的地方引入并建立连接
import { createSocket } from '@sven0706/websocket'
createSocket('wss://api.baidu.com')


// 发送消息
import { sendWSPush } from '@sven0706/websocket'
sendWSPush(data)

// 接收消息
const getsocketData = e => {  // 创建接收消息函数
  const data = e && e.detail.data
  console.log(data)
}
// 注册监听事件
window.addEventListener('onmessageWS', getsocketData)

// 在需要的时候卸载监听事件，比如离开页面
window.removeEventListener('onmessageWS', getsocketData)
 
 * 
 */


// ======================= API start ======================= \\

// {setWsParams, createSocket, sendWSPush, sendPing, endWS}
// 一般只需要用到`createSocket`, `sendWSPush`

/**
 * 建立websocket连接
 * @param {string} url ws地址
 */
// createSocket(url)

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
 // sendWSPush(message)

/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
 // sendPing()

// 设置自定义参数
// setWsParams(option);// wsKey, recreatFlag, wsOnopen, wsOnmessage

// 关闭webSoket
// endWS();

// ======================= API end ======================= \\



// WEBPACK FOOTER //
// ./src/global/global-websoket.js